import {
  isRequired,
  makeValidator,
  validEmailaddress
} from '../../../../../../forms/helpers/validators';

export const emailValidators = makeValidator(
  [isRequired, validEmailaddress],
  true
);
